export default "skymp5-front/e3d569164efdbe828f225fde8a7e1a26.gif";